import { render, staticRenderFns } from "./StructureTab.vue?vue&type=template&id=266c9a84&scoped=true&"
import script from "./StructureTab.vue?vue&type=script&lang=ts&"
export * from "./StructureTab.vue?vue&type=script&lang=ts&"
import style0 from "./StructureTab.vue?vue&type=style&index=0&id=266c9a84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266c9a84",
  null
  
)

export default component.exports